import styled from 'styled-components'

export const StyledHeading = styled.div`
    font-size: 26px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: normal;
    text-align: center;
    padding: 14px 12px 26px 12px;
    gap: 8px;
    position: relative;
`

export const StyledWhite = styled.div`
    color: ${({ theme }) => theme.colours.font.primary};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const StyledGreen = styled.span`
    color: ${({ theme }) => theme.colours.font.green};
`

export const StyledExpiringContainer = styled.div`
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colours.background.red};
    font-size: 13px;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 24px;
    position: relative;
    a {
        color: ${({ theme }) => theme.colours.font.primary};
        text-decoration: underline;
        margin-left: auto;
    }
`

export const StyledCloseButton = styled.div`
    position: absolute;
    top: -13px;
    right: -13px;
    color: ${({ theme }) => theme.colours.font.primary};
    cursor: pointer;
`

export const StyledLogoContainer = styled.div`
    cursor: pointer;
    flex-shrink: 0;
`

export const StyledLeftSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`

export const StyledRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`
